import { render, staticRenderFns } from "./searchGuestReminder.vue?vue&type=template&id=067c81e1&scoped=true"
import script from "./searchGuestReminder.vue?vue&type=script&lang=js"
export * from "./searchGuestReminder.vue?vue&type=script&lang=js"
import style0 from "./searchGuestReminder.vue?vue&type=style&index=0&id=067c81e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c81e1",
  null
  
)

export default component.exports